import { NotificationTypes, SafeAny } from '@/common/types';
import { axiosInstance } from '@/common/utils';

export const generateDraftReport = async (
  { rootState, state, commit }: SafeAny,
  payload: { sleepStudyID: string; scoreSet: string; sections: string[] }
) => {
  const url = `${rootState.env.requestUrl.reports}/studies/${payload.sleepStudyID}/report/`;

  state.draftReport.isLoading = true;

  try {
    const response = await axiosInstance.get<{ fileUrl: string }>(url, {
      params: {
        sections: payload.sections.join(','),
        draft: false
      }
    });
    state.draftReport.isLoading = false;
    state.draftReport.data = response.data;
  } catch (error: SafeAny) {
    state.draftReport.isLoading = false;
    state.draftReport.data = undefined;
    commit(
      'addNotification',
      {
        i18nTitle: 'errorGeneratingDraftReport',
        i18nDescription: error.message,
        type: NotificationTypes.Error
      },
      { root: true }
    );
  }
};
